<app-data-set
	#dataSet
	[dataSource]="dataSource"
	[rowId]="rowId"
	defaultPresentationMode="table"
	firstColumnProperty="property.name"
>
	@if (!hideToolbar) {
		<app-data-set-toolbar>
			<div *appSearchActionGroup style="flex: 1">
				<app-data-set-search
					defaultFilterName="propertyName"
					[defaultFilterLabel]="filterLabels.propertyName"
					[placeholder]="filterLabels.defaultPlaceholder"
				>
					<div class="filter-grid" [style.--columns]="4">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.propertyName }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('propertyName')"
									data-automation-id="property-name-input"
									(ngModelChange)="dataSet.filter('propertyName', filterLabels.propertyName, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.status }}</mat-label>
								<mat-select
									[ngModel]="dataSet.filter('active')"
									(ngModelChange)="dataSet.filter('active', filterLabels.status, $event, activeInactiveDropdownOptions)"
									data-automation-id="status-picker"
								>
									@for (option of activeInactiveDropdownOptions; track option) {
										<mat-option [value]="option.value" [attr.data-automation-id]="'status-' + option.label">{{
											option.label
										}}</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.hasPendingInstalls }}</mat-label>
								<mat-select
									[ngModel]="dataSet.filter('pendingInstalls')"
									(ngModelChange)="
										dataSet.filter('pendingInstalls', filterLabels.hasPendingInstalls, $event, yesNoDropdownOptions)
									"
									data-automation-id="has-pending-installs-picker"
								>
									@for (option of yesNoDropdownOptions; track option) {
										<mat-option [value]="option.value" [attr.data-automation-id]="'pending-installs-' + option.label">{{
											option.label
										}}</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.streetAddress }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('streetAddress')"
									data-automation-id="address-input"
									(ngModelChange)="dataSet.filter('streetAddress', filterLabels.streetAddress, $event)"
								/>
							</mat-form-field>
						</div>
					</div>
					<div class="filter-grid" [style.--columns]="4">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.townCity }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('locality')"
									data-automation-id="city-input"
									(ngModelChange)="dataSet.filter('locality', filterLabels.townCity, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.stateProvince }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('stateProvinceRegion')"
									data-automation-id="province-input"
									(ngModelChange)="dataSet.filter('stateProvinceRegion', filterLabels.stateProvince, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.postalCode }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('postalCode')"
									data-automation-id="postal-code-input"
									(ngModelChange)="dataSet.filter('postalCode', filterLabels.postalCode, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.country }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('countryCode')"
									data-automation-id="country-input"
									(ngModelChange)="dataSet.filter('countryCode', filterLabels.country, $event)"
								/>
							</mat-form-field>
						</div>
					</div>
				</app-data-set-search>
			</div>
			<div style="padding-left: 8px">
				<app-data-set-presentation-toggle
					data-automation-id="property-list-table-toggle"
				></app-data-set-presentation-toggle>
			</div>
			@if (canEditProperties) {
				<div *appActionGroup>
					<app-data-set-action-button
						icon="add"
						label="Add"
						i18n-label="@@propertyList-Add"
						(click)="onAddButtonClick()"
						data-automation-id="add-new-property-button"
					></app-data-set-action-button>
				</div>
			}
		</app-data-set-toolbar>
	}

	<app-data-set-content>
		<app-data-set-table-view [hidePaginator]="hideToolbar">
			@if (loadingService.isLoading(getPropertiesLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getPropertiesLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="propertyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyList-Name">Name</th>
					<td mat-cell *matCellDef="let row">{{ row.property.name }}</td>
				</ng-container>

				<ng-container matColumnDef="address">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyList-address2">Address</th>
					<td mat-cell *matCellDef="let row">
						<div [innerHtml]="row.property.address | address"></div>
					</td>
				</ng-container>

				<ng-container matColumnDef="devices">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyList-Devices">Devices</th>
					<td mat-cell *matCellDef="let row">{{ row.deviceCount }}</td>
				</ng-container>

				<ng-container matColumnDef="active">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyList-Status">Status</th>
					<td mat-cell *matCellDef="let row">
						<mat-chip-set>
							<mat-chip
								class="status-chip"
								[ngClass]="row.property.active ? 'status-chip-active' : 'status-chip-inactive'"
							>
								&bull;&NonBreakingSpace;
								@if (row.property.active) {
									<span i18n="@@propertyList-Active">Active</span>
								}
								@if (!row.property.active) {
									<span i18n="@@propertyList-Inactive">Inactive</span>
								}
							</mat-chip>
						</mat-chip-set>
					</td>
				</ng-container>

				<ng-container matColumnDef="pendingInstalls">
					<th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" i18n="@@propertyList-pendingInstalls">
						Pending Installs
					</th>
					<td mat-cell *matCellDef="let row">{{ row.property.pendingInstalls }}</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef mat-sort-header></th>
					<td mat-cell *matCellDef="let row">{{ row.name }}</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(appDataSetRowClick)="onRowClick(row.property)"
					[attr.data-automation-id]="'property-' + row.id + '-row'"
				></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>

	@if (!isUnitTesting) {
		<app-data-set-map-view [markersInfo]="markersInfo" [isPropertyMarker]="true"></app-data-set-map-view>
	}
</app-data-set>
